import IconDownload from 'components/Varios/IconDownload';
import React from 'react'

//BOOTSTRAP
import { Row, Col, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { DescargarConvenio } from './functionsConvenios';
import { propsCardInfoConvenios } from './TypesConvenios';

const CardInfoConvenios = (props: propsCardInfoConvenios) => {

    const { datosCards, indice, total } = props;
    return (

        <Card className="cardInfoConvenios">

            <CardBody className=" card-body cardBodyInfoConvenios">
                <p className='card-text '>
                    <b>{datosCards.objetoConvenio}</b>

                </p>
                <div> <span className='spanCard'>TIPO:</span> {datosCards.tipo}</div>
                {datosCards.organizacion && <div> <span className='spanCard'> ORGANIZACIÓN: </span> {datosCards.organizacion}</div>}
                <div> <span className='spanCard'> PAÍS: </span>{datosCards.pais}</div>
                <div>  <span className='spanCard'> FECHA DE INICIO DE CONVENIO: </span>  {datosCards.fechaInicio}</div>
                <div> <span className='spanCard'> FECHA DE FIN DE CONVENIO: </span> {datosCards.fechaFin}</div>
                <div> <span className='spanCard'> ESTADO: </span>  {datosCards.estado}</div>
            </CardBody>
            <CardFooter className="text-muted">
                <div style={{ float: "left" }}>
                    {indice}/{total}

                </div>
                <div style={{ float: "right" }}>
                    {datosCards.idArchivo && <IconDownload
                        onClick={() => DescargarConvenio(datosCards.idArchivo ? datosCards.idArchivo : "")}
                        nameToolTip='Descargar Convenio'
                    />}

                </div>



            </CardFooter>
        </Card>

    )
}

export default CardInfoConvenios